import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UsersService} from "../../../services/users/users.service";
import { ToastController, IonicModule } from '@ionic/angular';
import { BusinessService } from '../../../services/business/business.service';
import { Subscription } from 'rxjs';
import { NucampanalyticsService } from '../../../services/nucampanalytics/nucampanalytics.service';
import { NucampdatePipe } from '../../../pipes/nucampdate/nucampdate.pipe';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

/**
 * Generated class for the StudentprospectNotesEditComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'jobboard-messages-edit',
    templateUrl: 'jobboard-messages-edit.html',
    standalone: true,
    imports: [NgIf, IonicModule, FormsModule, NucampdatePipe]
})
export class JobBoardMessagesEditComponent implements OnChanges, OnInit {
  @Input() selectedJobPost;
  @Input() person;

  selectedJobPostId = null;
  formData: any;
  submitted = false;
  subsArr: Subscription[] = []
  isGraduate = false;
  isAdmin = false;

  defaultFormData = {
    jobpostId: null,
    personname: null,
    personemail: null,
    companyname: null,
    jobtitle: null,
    jobdescription: null,
    joblocation: null,
    jobtype: null,
    joburl: null,
    jobcontactname: null,
    jobcontactemail: null,
    jobcontactphone: null,
    datereceived: null,
    dateposted: null,
    status: 'in-review',
    reasonfordeclined: null
  };

  constructor(
    public userService: UsersService,
    private businessService: BusinessService,
    private toast: ToastController,
    private userdb: UsersService,
    private nucampAnalytics: NucampanalyticsService
    ) {
  }

  ngOnInit() {
    this.subsArr.push(this.userdb.checkrole(['graduate']).subscribe(value => this.isGraduate = value));
    this.subsArr.push(this.userdb.checkrole(['admin']).subscribe(value => this.isAdmin = value));
  }

  ionViewWillLeave() {
    this.subsArr.forEach(sub => sub.unsubscribe());
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes.person && changes.person.currentValue && changes.person.currentValue.email) {
      this.populatePersonBasedOnSelection();
    }
    if (changes.selectedJobPost && changes.selectedJobPost.currentValue && changes.selectedJobPost.currentValue.jobpostId) {
      this.populateJobpostBasedOnSelection();
    } else if (
      (changes.selectedJobPost && changes.selectedJobPost.currentValue && !changes.selectedJobPost.currentValue.jobpostId && changes.selectedJobPost.previousValue && changes.selectedJobPost.previousValue.jobpostId)
      || !changes.selectedJobPost.currentValue
      ) {
      this.populatePersonBasedOnSelection();
    } else if (changes.selectedJobPost && changes.selectedJobPost.currentValue && !changes.selectedJobPost.currentValue.jobpostId && changes.selectedJobPost.firstChange) {
      this.formData = {...this.defaultFormData, datereceived: new Date().toISOString()};
    }
  }

  populatePersonBasedOnSelection() {
    this.formData = {
      ...this.defaultFormData,
      datereceived: new Date().toISOString()
    };
    if (this.person && this.person.email) {
      this.formData.personemail = this.person.email
    }
  }

  validEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = re.test(String(email.trim().toLowerCase()).toLowerCase());
    return isValid;
  }

  populateJobpostBasedOnSelection() {
    if (this.selectedJobPost && this.selectedJobPost.jobpostId) {
      this.formData = {
        ...this.defaultFormData,
        ...this.selectedJobPost
      };
    } else {
      this.selectedJobPostId = this.selectedJobPost.jobpostId;
    }
  }
  
  browseJob() {
    this.nucampAnalytics.browseJob(this.userdb.loggedUser);
    // this.nucampAnalytics.startRecording();
  }

  submitForm() {
    const currentDate = new Date().toISOString();

    if (!this.formData.jobpostId) {
      this.formData.jobpostId = this.formData.personemail.replace(/@/g, "_") + '-' + currentDate.replace(/:/g, "-");
    }
    if (!this.formData.jobcontactname) {
      this.formData.jobcontactname = this.formData.personname;
    }
    if (!this.formData.jobcontactemail) {
      this.formData.jobcontactemail = this.formData.personemail;
    }


    const submissionData:any = {
      ...this.defaultFormData,
      ...this.formData,
    };

    return this.businessService.updateJobPosts(submissionData)
      .then(() => {
          this.formData = submissionData;
          this.submitted = true;
          this.nucampAnalytics.postJob(this.userdb.loggedUser);
          if (!this.isAdmin) {
            return this.toast
            .create({message: 'The job has been received and will be reviewed by our staff. You will receive an email in the next 24-48 hours. Thank you!', buttons: [{text: 'Ok', role: 'cancel', handler: () => {}}]})
            .then(ionicv5 => ionicv5.present());
          } else if (this.isAdmin) {
            return this.toast
            .create({message: 'The job has been updated.', buttons: [{text: 'Ok', role: 'cancel', handler: () => {}}]})
            .then(ionicv5 => ionicv5.present());
          }
        }
      )
      .catch(err => console.error(err))
  }
}
